import styled, { css } from 'styled-components'

type TagVariant = 'normative' | 'general'

const variantStyles = {
  normative: css`
    border-color: #b6dbfb;
    background: #e7f3fe;
  `,
  general: css`
    border-color: #d9d9d9;
    background: #f5f5f5;
  `,
}

export const Tag = styled.span<{ $variant: TagVariant }>`
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px;
  border: 1px solid;
  border-radius: 8px;
  color: #363636;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  white-space: nowrap;

  ${({ $variant }) => variantStyles[$variant]}
`
